var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default",null,{"stream":_vm.screenSharingStream,"enabled":_vm.screenSharingEnabled,"open":_vm.open,"close":_vm.closeCurrentStream})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }